import React, { Component } from 'react';
import dynamic from 'next/dynamic';
const Lottie = dynamic(() => import('react-lottie'), {
  ssr: false
});
export default function Loading({
  height = 40,
  width = 40,
  className
}: {
  height?: number;
  width?: number;
  className?: string;
}) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: 'svg'
  };
  return <Lottie className={className} options={defaultOptions} height={height} width={width} data-sentry-element="Lottie" data-sentry-component="Loading" data-sentry-source-file="Loading.tsx" />;
}
const animationData = {
  v: '5.12.1',
  fr: 60,
  ip: 0,
  op: 120,
  w: 320,
  h: 320,
  nm: 'fin',
  ddd: 0,
  assets: [{
    id: 'comp_0',
    nm: 'Frame 427321675',
    fr: 60,
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Rectangle 1451',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [120, 120, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 44.183], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [44.183, 0]],
              v: [[40, -40], [-40, -40], [-40, 40]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [1, 0.639215707779, 0.784313738346, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Rectangle 1451',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }],
      ip: 0,
      op: 300,
      st: 0,
      ct: 1,
      bm: 0
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Frame 427321675',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [80, 80, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ty: 'rc',
          d: 1,
          s: {
            a: 0,
            k: [160, 160],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 4
          },
          nm: 'Rectangle Path 1',
          mn: 'ADBE Vector Shape - Rect',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Frame 427321675',
        np: 1,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }],
      ip: 0,
      op: 300,
      st: 0,
      ct: 1,
      bm: 0
    }]
  }],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: '1',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [200, 40, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.667, 0.667, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 9.23,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 22.154,
          s: [19, 19, 100]
        }, {
          t: 36.923828125,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ty: 'rc',
        d: 1,
        s: {
          a: 0,
          k: [80, 80],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: 'Rectangle Path 1',
        mn: 'ADBE Vector Shape - Rect',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Rectangle 1445',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: '2',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [120, 40, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.667, 0.667, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 14.77,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 27.691,
          s: [19, 19, 100]
        }, {
          t: 42.4609375,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ty: 'rc',
        d: 1,
        s: {
          a: 0,
          k: [80, 80],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: 'Rectangle Path 1',
        mn: 'ADBE Vector Shape - Rect',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Rectangle 1444',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: '2.1',
    cl: '1',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [80, 80, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [-40, -40, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.667, 0.667, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 20.309,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 33.23,
          s: [0, 0, 100]
        }, {
          t: 48,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-44.183, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, -44.183]],
            v: [[40, -40], [-40, -40], [-40, 40]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Subtract',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: '3',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [40, 120, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.667, 0.667, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 25.846,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 39.631,
          s: [19, 19, 100]
        }, {
          t: 55.384765625,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ty: 'rc',
        d: 1,
        s: {
          a: 0,
          k: [80, 80],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: 'Rectangle Path 1',
        mn: 'ADBE Vector Shape - Rect',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Rectangle 1446',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: '4',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [40, 200, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.667, 0.667, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 31.385,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 46.893,
          s: [19, 19, 100]
        }, {
          t: 64.615234375,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ty: 'rc',
        d: 1,
        s: {
          a: 0,
          k: [80, 80],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: 'Rectangle Path 1',
        mn: 'ADBE Vector Shape - Rect',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Rectangle 1447',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: '4.1',
    cl: '1',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [80, 240, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [-40, 40, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.667, 0.667, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 38.77,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 56.002,
          s: [0, 0, 100]
        }, {
          t: 75.69140625,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-44.183, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 44.183]],
            v: [[40, 40], [-40, 40], [-40, -40]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Subtract',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 7,
    ty: 4,
    nm: '5',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [120, 280, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.667, 0.667, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 46.154,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 65.967,
          s: [19, 19, 100]
        }, {
          t: 88.615234375,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ty: 'rc',
        d: 1,
        s: {
          a: 0,
          k: [80, 80],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: 'Rectangle Path 1',
        mn: 'ADBE Vector Shape - Rect',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Rectangle 1448',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 8,
    ty: 4,
    nm: '6',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [200, 280, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.667, 0.667, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 53.539,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 76.799,
          s: [19, 19, 100]
        }, {
          t: 103.384765625,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ty: 'rc',
        d: 1,
        s: {
          a: 0,
          k: [80, 80],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: 'Rectangle Path 1',
        mn: 'ADBE Vector Shape - Rect',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Rectangle 1449',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 9,
    ty: 4,
    nm: '7',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [280, 200, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.933, 0.933, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [1, 1, 0.333],
            y: [0, 0, 0]
          },
          t: 60.924,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.051, 0.051, 0.333],
            y: [0, 0, 0]
          },
          t: 88.492,
          s: [19, 19, 100]
        }, {
          t: 120,
          s: [100, 100, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ty: 'rc',
        d: 1,
        s: {
          a: 0,
          k: [80, 80],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: 'Rectangle Path 1',
        mn: 'ADBE Vector Shape - Rect',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0.639215707779, 0.784313738346, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Rectangle 1450',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }, {
    ddd: 0,
    ind: 10,
    ty: 0,
    nm: 'Frame 427321675',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 0,
          s: [0]
        }, {
          t: 120,
          s: [-360]
        }],
        ix: 10
      },
      p: {
        a: 0,
        k: [160, 160, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [80, 80, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 160,
    h: 160,
    ip: 0,
    op: 300,
    st: 0,
    ct: 1,
    bm: 0
  }],
  markers: [],
  props: {}
};